module.exports = __webpack_public_path__ + "static/wallpaper3-accb270e2c93ddb80ca67db6011ea780.jpg";